import { SERVER_CHECK, TOGGLE_STATUS } from '../actionTypes';

const initalState = {
  username: '',
  password: '',
  isButtonDisabled: true,
  helperText: '',
  isLoginError: false,
  drawerStatus: false,
};

const ScaffoldingReducer = (state = initalState, action) => {
  switch (action.type) {
    case SERVER_CHECK: {
      return {
        ...state,
        serverStatus: action.payload,
      };
    }
    case TOGGLE_STATUS: {
      return {
        ...state,
        drawerStatus: action.newState,
      };
    }
    default:
      return state;
  }
};

export default ScaffoldingReducer;
